import { Link } from "react-router-dom";
import { films } from "@/mocks/films";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "欧美伦理电影",
    desc: "从长篇叙事到克制留白，精选那些把伦理困境拍成一面镜子的电影。",
    type: "movie" as const,
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "欧美伦理电视剧",
    desc: "多线群像与逐集推进，在更长的篇幅里看清一个选择的来龙去脉。",
    type: "tv" as const,
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
      {entries.map((entry) => {
        const count = films.filter((f) => f.type === entry.type).length;
        return (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative flex items-start gap-4 md:gap-5 p-5 md:p-7 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer overflow-hidden"
          >
            <div className="absolute -right-6 -bottom-6 w-32 h-32 rounded-full bg-primary-50 group-hover:bg-accent-100 transition-colors duration-300"></div>
            <span className="relative z-10 w-14 h-14 md:w-16 md:h-16 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 group-hover:bg-accent-500 group-hover:text-foreground-950 transition-colors duration-300">
              <i className={`${entry.icon} text-2xl md:text-3xl`}></i>
            </span>
            <div className="relative z-10 flex-1">
              <div className="flex items-center justify-between gap-3">
                <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-950">{entry.title}</h3>
                <i className="ri-arrow-right-up-line text-xl text-foreground-400 group-hover:text-primary-600 transition-colors"></i>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{entry.desc}</p>
              <span className="inline-flex items-center gap-1 mt-4 text-xs font-medium text-primary-600">
                共 {count} 部作品
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}